module.exports = __webpack_public_path__ + "static/media/case_explorer.11eef22b.png";